module.exports = __webpack_public_path__ + "img/ibms_sold_out_en@2x.7b721c4d.png";